import React from "react";
import "../../styles/components/SponsorCard.scss";
import SliderPanel from "../SliderPanel";
import { Button } from "react-bootstrap";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { FieldInput, FieldInputNumber } from "../Forms";
import {
  distributionFormFields,
  manageDistributionFormNames,
} from "../../utils";
import { get, isEmpty } from "lodash-es";
import { getTransformedBankDetails } from "../../containers/Distribution/WithdrawalRequestContainerOld/WithdrawalRequestContainer";
const BankSlide = (props) => {
  const {
    bankInformationDetails,
    setBankSlideOpen,
    bankSlideOpen,
    onBankSave,
    values,
    //fields,
    bankAdded,
    setBankAdded,
    setFieldValue,
    //handleChange,
    accountTypeOptions,
    FieldButtonGroup,
    index,
    isLoanRequest = false,
    isRepaymentBankInfo,
  } = props;

  const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
  const fields = distributionFormFields[formName];
  let initialValues = null;
  if (!isLoanRequest)
    initialValues = !isEmpty(get(bankInformationDetails, index, []))
      ? bankInformationDetails[index][bankInformationDetails[index].length - 1]
      : null;
  else initialValues = get(bankInformationDetails, "0");
  // const checkSplChar = (val) => {
  //   const format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  //   if (format.test(val) === true) return true;
  //   else return false;
  // };
  const validationSchema = Yup.object().shape({
    bankName: Yup.string()
      .required(`${isLoanRequest ? "LO049" : "WL019"} : Required`)
      .max(
        50,
        `${
          isLoanRequest ? "LO050" : "WL020"
        } : Name of financial institution should not exceed 50 characters.`
      )
      .test(
        "bankName",
        `${
          isLoanRequest ? "LO051" : "WL021"
        } : Name of financial institution should contain only alphabets, spaces and hyphen `,
        (val) => !checkSplChar(val)
      ),

    accountHolderName: Yup.string()
      .required(`${isLoanRequest ? "LO052" : "WL022"} : Required`)
      .max(
        150,
        `${
          isLoanRequest ? "LO053" : "WL023"
        } : Account holder name should not exceed 150 characters.`
      ),

    accountType: Yup.string().required(
      `${isLoanRequest ? "LO054" : "CM047"} : Required`
    ),
    accountNumber: Yup.string()
      .required(`${isLoanRequest ? "LO055" : "WL016"} : Required`)
      .max(
        18,
        `${
          isLoanRequest ? "LO056" : "WL017"
        }: Account number should not exceed 18 characters`
      ),
    creditUnion: Yup.string()
      .required(`${isLoanRequest ? "LO057" : "WL051"} : Required`)
      .max(
        9,
        `${
          isLoanRequest ? "LO058" : "WL018"
        }: Routing number of bank or credit union should not exceed 9 characters.`
      ),
  });

  const checkSplChar = (val) => {
    const format = /[0-9!@#$%^&*()_+\=\[\]{};':"\\|,.<>\/?]+/;
    if (format.test(val) === true) return true;
    else return false;
  };
  const onFormSubmit = (values) => {
    onBankSave(values, index, isRepaymentBankInfo, setFieldValue);
    if (!isLoanRequest)
      setFieldValue(
        `[distribution]${index}.bankInformation`,
        getTransformedBankDetails(values)
      );
    setBankSlideOpen(null);
    // setBankAdded(bankInformationDetails.length);
  };

  return (
    <SliderPanel
      isOpen={
        bankSlideOpen === index || (isLoanRequest && bankSlideOpen === true)
      }
      size="40"
      showCancel={false}
      backdropClicked={() => setBankSlideOpen(null)}
    >
      <Formik
        onSubmit={onFormSubmit}
        enableReinitialize
        validateOnChange={false}
        validationSchema={validationSchema}
        validateOnBlur={false}
        initialValues={{
          bankName: initialValues?.nameOfTheFinancialInstitution,
          accountHolderName: initialValues?.accountHolderName,
          accountType: initialValues?.typeOfAccount,
          accountNumber: initialValues?.checkingSavingsAccountNumber,
          creditUnion: initialValues?.abaRoutingNumberforBankOfCreditUnion,
        }}
      >
        {(formProps) => {
          const {
            handleChange,
            setFieldValue,
            handleSubmit,
            setValues,
            setTouched,
            values,
            setSubmitting,
            setFieldError,
            fieldValue,
            ...rest
          } = formProps;

          return (
            <Form onSubmit={handleSubmit}>
              <div className="d-flex flex-row space-between mb-20 fw-500 ft-16 .Border-Bottom-Bank align-items-center">
                <p className="ft-16 fw-500">Add Bank details</p>
                <div>
                  <Button
                    className="marg-right-10 mb-20"
                    variant="secondary"
                    onClick={() => setBankSlideOpen(null)}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="w-100px  mb-20"
                    // onClick={() => {
                    //   // onBankSave(values);
                    //   // setBankAdded(true);
                    // }}
                    type="Submit"
                  >
                    Save
                  </Button>
                </div>
              </div>
              <div className="disp-flex-col">
                <Field
                  size="smd"
                  isRequired
                  placeholder=" "
                  label={"Name of financial instituion"}
                  name={"bankName"}
                  type="text"
                  value={values[fields.bankName]}
                  onChange={handleChange}
                  component={FieldInput}
                />

                <Field
                  size="smd"
                  isRequired
                  placeholder=" "
                  label={"Account holder name"}
                  name={"accountHolderName"}
                  type="text"
                  value={values[fields.accountHolderName]}
                  onChange={handleChange}
                  component={FieldInput}
                />

                <Field
                  isRequired
                  name={"accountType"}
                  size="sm"
                  label={"Account type"}
                  options={accountTypeOptions}
                  selectedValue={values[fields.accountType]}
                  onChange={(value) => {
                    setFieldValue(fields.accountType, value);
                  }}
                  //disabled={isEdit && !isSave}
                  component={FieldButtonGroup}
                />
                <Field
                  size="smd"
                  placeholder=" "
                  isRequired
                  label={"Account Number (Checking or Saving)"}
                  name={"accountNumber"}
                  type="text"
                  value={values[fields.accountNumber]}
                  onChange={handleChange}
                  component={FieldInputNumber}
                />

                <Field
                  size="smd"
                  placeholder=" "
                  isRequired
                  label={"Routing Number Of bank or credit union"}
                  name={"creditUnion"}
                  type="text"
                  value={values[fields.creditUnion]}
                  onChange={handleChange}
                  component={FieldInputNumber}
                />
              </div>
            </Form>
          );
        }}
      </Formik>
    </SliderPanel>
  );
};

export default BankSlide;
